<template>
  <div>
    <div v-if="trocas.length" class="detail-table-wrap">
      <table class="detail-table alt-table">
        <colgroup>
          <col class="col-chevron" />
          <col class="col-voucher" />
          <col class="col-servico" />
          <col class="col-execucao" />
          <col class="col-situacao" />
          <col class="col-visto" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Voucher / Reserva</th>
            <th>Serviço</th>
            <th>Execução</th>
            <th>Situação</th>
            <th>Visto em</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(troca, indice) in trocas">
            <tr
              :key="id(troca, indice)"
              class="import-row"
              :class="{ 'is-open': openId === id(troca, indice) }"
              @click="toggle(id(troca, indice))"
            >
              <td class="chevron-cell">
                <v-icon
                  size="18"
                  class="chevron"
                  :class="{ 'is-open': openId === id(troca, indice) }"
                  >mdi-chevron-right</v-icon
                >
              </td>
              <td class="voucher-cell">
                {{ troca.voucher || "—" }}
                <small class="muted">{{ troca.codigoReserva || "—" }}</small>
              </td>
              <td>
                <div
                  v-for="(item, itemIndice) in troca.trocas || []"
                  :key="itemIndice"
                  class="stacked-value"
                >
                  {{ nome(item.de, "passeio a escolher") }} →
                  {{ nome(item.para, "serviço a escolher") }}
                </div>
                <span v-if="!(troca.trocas || []).length" class="muted">—</span>
              </td>
              <td>
                <div
                  v-for="(item, itemIndice) in troca.trocas || []"
                  :key="itemIndice"
                  class="stacked-value muted"
                >
                  {{ periodo(item.dataAntes, item.dataDepois) }}
                </div>
                <span v-if="!(troca.trocas || []).length" class="muted">—</span>
              </td>
              <td>
                <span class="rate-pill" :class="pillClass(troca)">
                  {{ situacao(troca) }}
                </span>
              </td>
              <td class="muted">{{ dataHora(troca.quando) }}</td>
            </tr>
            <tr
              v-if="openId === id(troca, indice)"
              :key="id(troca, indice) + '-det'"
              class="import-detail-row"
            >
              <td colspan="6">
                <div class="alt-panel">
                  <template v-if="(troca.trocas || []).length">
                    <div class="alt-summary">
                      <span class="alt-summary-n">
                        {{ troca.trocas.length }}
                        {{ troca.trocas.length > 1 ? "trocas aplicadas" : "troca aplicada" }}
                      </span>
                    </div>
                    <table class="alt-cmp">
                      <thead>
                        <tr>
                          <th>Seção / Campo</th>
                          <th class="alt-cmp-phx">Antes</th>
                          <th class="alt-cmp-cvc">Depois</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(item, itemIndice) in troca.trocas">
                          <tr
                            v-if="troca.trocas.length > 1"
                            :key="'secao-' + itemIndice"
                            class="alt-cmp-sec"
                          >
                            <td colspan="3">Troca {{ itemIndice + 1 }}</td>
                          </tr>
                          <tr :key="'servico-' + itemIndice" class="is-diff">
                            <td class="alt-cmp-label">Serviço</td>
                            <td class="alt-cmp-a">
                              {{ nome(item.de, "passeio a escolher") }}
                            </td>
                            <td class="alt-cmp-b">
                              {{ nome(item.para, "serviço a escolher") }}
                            </td>
                          </tr>
                          <tr :key="'data-' + itemIndice" class="is-diff">
                            <td class="alt-cmp-label">Data de execução</td>
                            <td class="alt-cmp-a" :class="{ 'is-empty': !item.dataAntes }">
                              {{ data(item.dataAntes) || "(em branco)" }}
                            </td>
                            <td class="alt-cmp-b" :class="{ 'is-empty': !item.dataDepois }">
                              {{ data(item.dataDepois) || "(em branco)" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </template>
                  <p v-else class="alt-note alt-note--bad">
                    {{ detalheSemTrocas(troca) }}
                  </p>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      Nenhuma troca de serviço no período.
    </div>
  </div>
</template>

<script>
const motivos = {
  faturado: "Reserva faturada: não pode ser trocada",
  ja_tem_servico_a_escolher: "Já tem serviço a escolher",
  filhas: "Reserva com reservas filhas",
  services_chosen: "Já tem escolhas feitas",
  escolhas: "Já tem escolhas feitas",
  item_em_operacao: "Item já em operação",
  "item_status_<>2": "Item com status diferente de ativo",
  reserva_cancelada: "Reserva cancelada",
  reserva_excluida: "Reserva excluída",
  reserva_rascunho: "Reserva em rascunho",
  sem_data_e_sem_IN: "Sem data e sem IN para calcular a data",
};

const resumoMotivos = {
  faturado: "Faturada",
  ja_tem_servico_a_escolher: "Já tem serviço a escolher",
  filhas: "Com reservas filhas",
  services_chosen: "Já tem escolhas feitas",
  escolhas: "Já tem escolhas feitas",
  item_em_operacao: "Item em operação",
  "item_status_<>2": "Item inativo",
  reserva_cancelada: "Reserva cancelada",
  reserva_excluida: "Reserva excluída",
  reserva_rascunho: "Reserva em rascunho",
  sem_data_e_sem_IN: "Sem data e sem IN",
};

const nomesServicoTroca = {
  234: "1 Passeio a escolher",
  235: "2 Passeios a escolher",
  236: "3 Passeios a escolher",
  250: "1 Serviço a escolher",
  249: "2 Serviços a escolher",
  243: "3 Serviços a escolher",
};

export default {
  name: "PlanilhaTrocaServico",
  props: {
    trocas: { type: Array, default: () => [] },
  },
  data() {
    return { openId: null };
  },
  methods: {
    id(troca, indice) {
      return `${troca.runId || "run"}-${troca.codigoReserva || troca.voucher || indice}`;
    },
    toggle(id) {
      this.openId = this.openId === id ? null : id;
    },
    nome(servico, padrao) {
      const item = servico || {};
      return nomesServicoTroca[item.servicoId] || item.nome || padrao;
    },
    data(valor) {
      const match = String(valor || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
      return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
    },
    dataHora(valor) {
      return valor ? String(valor) : "—";
    },
    periodo(antes, depois) {
      const a = this.data(antes);
      const b = this.data(depois);
      if (!a && !b) return "—";
      return !b || a === b ? a || b : `${a} → ${b}`;
    },
    motivoLegivel(troca) {
      if (troca.status === "error") {
        return `Erro ao trocar: ${String(troca.motivo || troca.texto || "erro não informado").slice(0, 480)}`;
      }
      return motivos[troca.motivo] || troca.motivo || "Motivo não informado";
    },
    detalheSemTrocas(troca) {
      if (troca.status === "success") return troca.texto || "Troca aplicada";
      return this.motivoLegivel(troca);
    },
    resumoMotivo(troca) {
      if (troca.status === "error") {
        return String(troca.motivo || troca.texto || "erro não informado").slice(0, 90);
      }
      return resumoMotivos[troca.motivo] || troca.motivo || "Motivo não informado";
    },
    situacao(troca) {
      if (troca.status === "success") return "Trocada";
      if (troca.status === "dry-run") return "Simulada";
      if (troca.status === "skipped") return `Não trocada · ${this.resumoMotivo(troca)}`;
      return `Erro · ${this.resumoMotivo(troca)}`;
    },
    pillClass(troca) {
      if (troca.status === "success") return "rate-pill--ok";
      if (troca.status === "dry-run") return "rate-pill--info";
      if (troca.status === "skipped") return "rate-pill--warn";
      return "rate-pill--bad";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.alt-table {
  table-layout: fixed;
  width: 100%;
  min-width: 920px;

  col.col-chevron { width: 40px; }
  col.col-voucher { width: 18%; }
  col.col-servico { width: 23%; }
  col.col-execucao { width: 16%; }
  col.col-situacao { width: 25%; }
  col.col-visto { width: 18%; }

  th, td {
    white-space: normal;
    vertical-align: top;
    word-break: break-word;
  }
}

.voucher-cell {
  font-weight: 700;
  color: #384049;
  font-variant-numeric: tabular-nums;

  small { display: block; margin-top: 2px; font-size: 0.72rem; font-weight: 400; }
}
.stacked-value + .stacked-value { margin-top: 5px; }
.import-row {
  cursor: pointer;
  &:hover td { background: #f3f6f7; }
  &.is-open td { background: #f4f9f8 !important; }
}
.chevron-cell { padding-right: 0; padding-left: 12px; }
.chevron {
  transition: transform 0.15s ease;
  color: #9aa2ab;
  &.is-open { transform: rotate(90deg); color: #0f7a6e; }
}
.import-detail-row td { padding: 10px 14px 16px 48px; background: #f4f9f8; }
.alt-panel { display: flex; flex-direction: column; gap: 10px; }
.alt-summary { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; font-size: 0.82rem; }
.alt-summary-n {
  background: #fff6dc;
  border: 1px solid #f0d58a;
  color: #7a5a00;
  font-weight: 700;
  border-radius: 20px;
  padding: 3px 12px;
}
.alt-note {
  font-size: 0.82rem;
  margin: 0;
  border: 1px dashed #f0b8b8;
  border-radius: 8px;
  padding: 9px 12px;
  &--bad { background: #fdf3f3; color: #8a2a2a; }
}
.alt-cmp {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 10px;
  overflow: hidden;
  font-size: 0.8rem;
  th { padding: 8px 12px; text-align: left; color: #fff; font-size: 0.78rem; width: 38%; }
  th:first-child { width: 24%; background: #f7f9fa; color: #6b747d; }
  .alt-cmp-phx { background: #a23a3a; }
  .alt-cmp-cvc { background: #17603b; }
  td { padding: 7px 12px; vertical-align: top; border-top: 1px solid #eef0f2; color: #2b333b; word-break: break-word; }
  .alt-cmp-label { color: #6b747d; font-size: 0.76rem; }
  .alt-cmp-sec td { background: #f7f9fa; font-size: 0.68rem; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase; color: #8a939c; padding: 5px 12px; }
  tr.is-diff td.alt-cmp-a { background: #fdf3f3; color: #a23a3a; text-decoration: line-through; text-decoration-color: #e2b0b0; }
  tr.is-diff td.alt-cmp-b { background: #eef8f1; color: #17603b; font-weight: 700; }
  tr.is-diff td.is-empty { text-decoration: none; }
  td.is-empty { color: #b3bac1; font-weight: 400 !important; }
}
.rate-pill--info { background: #eaf1fb; color: #2f5fa7; }
</style>
